export default "__VITE_ASSET__CmQLdVRl__"